import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  vehicle: "",
};

const driverFormSlice = createSlice({
  name: "driverForm",
  initialState,
  reducers: {
    setDriverForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetDriverForm: () => initialState,
  },
});

export const { setDriverForm, resetDriverForm } = driverFormSlice.actions;
export default driverFormSlice.reducer;
